export const SERVICE_NAMES: Record<string, string> = {
  aed: "Booking.com",
  bsj: "Pagaleve",
  ln: "Grofers",
  mj: "Zalo",
  full: "Full rent",
  go: "Google,youtube,Gmail",
  fb: "facebook",
  ig: "Instagram+Threads",
  am: "Amazon",
  wa: "Whatsapp",
  lf: "TikTok/Douyin",
  tg: "Telegram",
  ds: "Discord",
  dr: "OpenAI",
  gp: "Ticketmaster",
  wb: "WeChat",
  tw: "Twitter/X",
  ot: "Any other",
  oi: "Tinder",
  ccu: "Google Chat",
  ka: "Shopee",
  qf: "RedBook",
  ni: "Gojek",
  ub: "Uber",
  cq: "Mercado",
  jg: "Grab",
  wr: "Walmart",
  mb: "Yahoo",
  ts: "PayPal",
  hw: "Alipay/Alibaba/1688",
  kc: "Vinted",
  nv: "Naver",
  vi: "Viber",
  fr: "Dana",
  mm: "Microsoft",
  yw: "Grindr",
  vz: "Hinge",
  ew: "Nike",
  bw: "Signal",
  aoy: "PLN Mobile",
  me: "Line messenger",
  fu: "Snapchat",
  ki: "99app",
  dh: "eBay",
  im: "Imo",
  wx: "Apple",
  nf: "Netflix",
  tn: "LinkedIN",
  aop: "Kleinanzeigen",
  vm: "OkCupid",
  abk: "GMX",
  df: "Happn",
  xk: "DiDi",
  ok: "ok.ru",
  ac: "DoorDash",
  abu: "BPJSTK",
  aka: "LinkAja",
  alg: "Ankama",
  vk: "vk.com",
  pf: "pof.com",
  vr: "MotorkuX",
  sg: "OZON",
  xh: "OVO",
  bzk: "Amaze Super App",
  dl: "Lazada",
  fz: "KFC",
  ev: "Picpay ",
  xd: "Tokopedia",
  mo: "Bumble",
  tm: "Akulaku",
  nz: "Foodpanda",
  anx: "InfinitePay",
  blt: "INDOPAKET",
  sn: "OLX",
  ue: "Onet",
  ya: "Yandex",
  tx: "Bolt",
  bz: "Blizzard",
  bwv: "Manus",
  pc: "Casino/bet/gambling",
  zk: "Deliveroo",
  ada: "TRUTH SOCIAL",
  zs: "Bilibili",
  bgv: "Clearpay",
  qj: "Whoosh",
  aim: "Firebase",
  aaa: "Nubank",
  mt: "Steam",
  uf: "Eneba",
  xx: "Joyride",
  zh: "Zoho",
  afp: "VFS GLOBAL",
  ang: "TOMORO COFFEE",
  cn: "Fiverr",
  bex: "Whatnot",
  blz: "MiniPay",
  awv: "Wallapop",
  bxy: "MAX",
  yx: "JTExpress",
  fv: "Vidio",
  pm: "AOL",
  zm: "OfferUp",
  abc: "Taptap Send",
  do: "Leboncoin",
  aba: "Rappi",
  pd: "IFood",
  acz: "Claude ",
  axj: "FIFGROUP MOBILE CUSTOMER",
  aez: "Shein",
  byf: "SeaBank",
  ah: "EscapeFromTarkov",
  bpc: "LOVOO",
  nc: "Payoneer",
  rr: "Wolt",
  axx: "Shopback",
  yl: "Yalla",
  amb: "Vercel",
  qv: "Badoo",
  aik: "ZUS Coffee",
  ars: "Bingo Plus",
  bib: "myBCA",
  bnl: "Reddit",
  hc: "MOMO",
  anh: "Cadbury",
  apr: "Capital One",
  akp: "Her",
  als: "Greggs ",
  bwu: "SkyBet",
  ahl: "Maxim",
  aqt: "Skrill",
  uk: "Airbnb",
  abn: "Bybit",
  azi: "TheL",
  bc: "GCash",
  kt: "KakaoTalk",
  za: "JDcom",
  abg: "PagBank",
  adu: "Seznam",
  agl: "Betano",
  aon: "Binance",
  asb: "YUEWEN 阅文集团",
  hx: "AliExpress",
  bgt: "Alfamidi",
  aiw: "Roblox",
  cw: "PaddyPower",
  jq: "Paysafecard",
  cau: "Ero Me",
  arf: "Enjoei",
  bqh: "PEDIR GAS",
  byh: "Adobe",
  wh: "TanTan",
  aym: "Langit Musik",
  cj: "Dotz",
  qq: "Tencent QQ",
  ua: "BlaBlaCar",
  bl: "BIGO LIVE",
  gf: "GoogleVoice",
  ns: "Oldubil",
  akr: "Voi",
  bo: "Wise",
  gq: "Freelancer",
  re: "Coinbase",
  aff: "C6 Bank",
  afs: "Privalia",
  afz: "Klarna",
  bfg: "EMAG",
  bpt: "SerpApi ",
  bru: "myPOS",
  ef: "Nextdoor",
  ip: "Burger King",
  uu: "Wildberries",
  acm: "Razer",
  akd: " Feels",
  ayz: "Kimi",
  bcx: "Bantusaku",
  bkd: "Sahibinden",
  cp: "Uklon",
  ep: "Temu",
  fk: "BLIBLI",
  gj: "Carousell",
  mx: "SoulApp",
  nh: "AlloBank",
  atl: "Watsons MY",
  awz: "PlayTime",
  axn: "FastMoss",
  bn: "Alfagift",
  ccl: "Cruzeiro",
  zy: "Nttgame",
  afr: "Ultragaz",
  ark: "SageMaker Studio Lab",
  auh: "KeeTa 美团",
  bny: "Suno",
  brk: "Indeed",
  hb: "Twitch",
  ij: "Revolut",
  kk: "Idealista",
  km: "Rozetka",
  lj: "Santander",
  ry: "McDonalds",
  tu: "Lyft",
  abe: "Foodora",
  abo: "WEBDE",
  app: "ClassPass",
  aup: "Botim",
  ber: "Gumtree",
  btr: "Duet",
  bwx: "Chagee",
  dp: "ProtonMail",
  kf: "Weibo",
  rl: "inDriver",
  xs: "GroupMe",
  agm: "CMB",
  ajj: "Rebtel",
  ani: "Talabat",
  aws: "7-Eleven",
  axr: "Match",
  bbq: "Chime",
  bfo: "MSport",
  bii: "MEXC",
  bkk: "Poparide",
  btn: "Itau",
  bzo: "SeLoger",
  sa: "AGIBANK",
  sr: "Starbucks",
  ww: "BIP",
  zd: "Zilch",
  afe: "GovBr",
  agj: "Marktplaats",
  ahb: "Ubisoft",
  ahi: "Daki",
  ahj: "Strato",
  ahx: "Bitrue",
  alm: "Muzz",
  aor: "OKX",
  aq: "Glovo",
  arp: "Continente",
  atn: "Fawry",
  atr: "RIDE ",
  axt: "GNJOY",
  cbs: "lalafo",
  ex: "Linode",
  ht: "Bitso",
  ti: "cryptocom",
  vg: "ShellBox",
  yy: "Venmo",
  adt: "willhaben",
  aem: "AstraPay",
  afn: "roomster",
  agw: "Adverts",
  ahe: "Bunq",
  aiq: "Prime Opinion",
  ais: "DiDiFood",
  aix: "Move It",
  ajn: "Gopuff",
  alj: "Spotify",
  anm: "CaltexGO",
  aoi: "Cryptonow",
  aok: "NETELLER",
  aqy: "SAPO",
  aux: "Lightning AI",
  auz: "Outlier",
  avb: "Tealive",
  bgj: "MoonPay",
  bli: "Scalapay",
  blm: "Epic Games ",
  bow: "Affirm",
  bqe: "Lottomatica",
  bwa: "Hostinger",
  ee: "Twilio",
  ff: "AVON",
  fs: "Şikayet var",
  ge: "Paytm",
  hu: "Ukrnet",
  ie: "bet365",
  pz: "Lidl",
  qe: "GG",
  rs: "Lotus",
  rt: "hily",
  wg: "Skout",
  zo: "Kaggle",
  abh: "UOL Host",
  ael: "Cloud Manager",
  aer: "PlayerAuctions",
  afm: "myboost",
  aga: "Publi24",
  agd: "Grailed",
  ait: "FeetFinder",
  aiv: "Remitly",
  aiz: "Brevo",
  ako: "Ryde",
  alb: "Guiche Web",
  anj: "Gemini",
  anl: "AttaPoll",
  aoe: "Sendwave",
  aol: "Paysera",
  aoz: "ReclameAQUI",
  apb: "eToro",
  apd: "2dehands",
  apf: "Carrefour",
  aps: "Skelbiu",
  auc: "TotalPass",
  awr: "KCEX",
  axp: "ChargePoint",
  bab: "Opera Mini",
  bbl: "Autodesk",
  bbm: "TrueMoney",
  bdg: "HUD",
  bdh: "Singledk",
  bfa: "Webmotors ",
  bfr: "Dott",
  bfw: "Finya",
  bhr: "Dil Mil",
  bji: "Perfect World 完美世界",
  ble: "Nexon",
  bmd: "VooV Meeting",
  bmi: "Sisal",
  bmx: "Canal RCN",
  bpi: "Askable",
  bqb: "Weex",
  bqr: "ASAAS",
  bra: "Touch n Go TNG",
  bre: "Лемана ПРО",
  bsu: "Dingtone",
  btd: "Volcengine 火山引擎",
  bxg: "BAT",
  bxi: "Grupo Madero",
  byd: "Airtasker",
  cbk: "Fastwork",
  dg: "Mercari",
  dy: "Zomato",
  em: "ZéDelivery",
  et: "Clubhouse",
  fd: "Mamba",
  fh: "Lalamove",
  gm: "Mocospace",
  gr: "Astropay",
  ji: "Monobank",
  lc: "Subito",
  li: "Baidu",
  ma: "Mail.ru",
  mv: "Fruitz",
  nq: "Trip",
  tr: "Paysend",
  tv: "Flink",
  vd: "Betfair",
  wc: "Craigslist",
  xy: "Depop",
  yi: "Yemeksepeti",
  yn: "Allegro",
  ze: "Shpock",
  zp: "Pinduoduo",
  aag: "Pockit",
  aaq: "Netease",
  aav: "Alchemy ",
  aax: "Boyaa",
  aaz: "Ozan",
  abb: "Coca-Cola",
  abd: "BeBoo",
  abq: "Upwork",
  abt: "ArenaPlus",
  acb: "Spark Driver",
  acc: " LuckyLand Slots",
  aci: "Colombian Cupid",
  adc: "PlayOJO",
  adp: "Cabify",
  aet: "Greywoods",
  aeu: "TheFork",
  aex: "Neon",
  aey: "Next",
  afd: "Astra Otoshop",
  afk: "Chevron",
  agg: "OneForma",
  agh: "Getnet",
  agk: "Ipsos iSay",
  agv: "DoneDeal",
  ahv: "Curve",
  ajq: "MyValue",
  aju: "Daya Auto",
  ajv: "ShareParty",
  ajy: "All Access",
  akj: "Easycash",
  akl: "DOKU",
  akm: "LOTTE Mart",
  alo: "Profee",
  alx: "NutriClub",
  aly: "Bebeclub",
  ama: "WooPlus",
  amw: "Tise",
  ana: "Sicredi",
  anb: "Abastece-aí",
  ane: "Supercell",
  ann: "Bradesco",
  ano: "Shopify",
  anq: "Hitnspin",
  aof: "Guzman y Gomez",
  aoh: "YooMoney",
  aom: "Monzo",
  aoo: "Pegasus Airlines",
  aow: "Geekay",
  apg: "Damai",
  api: "KKTIX",
  apl: "Sideline",
  apo: "Netmarble",
  apq: "WePoker",
  aqj: "BigBasket",
  are: "Seated",
  ari: "Ring4",
  asf: "TextFree",
  asp: "PhonePe",
  atp: "Vonage",
  atu: "Sber/Cooper",
  aua: "同程旅行 Tongcheng Travel",
  aub: "Smitten",
  avj: "SumUp ",
  avk: "Quoka ",
  avv: "shopFarEast",
  awg: "Natura Avon",
  awq: "Atlas Earth",
  awu: "MosGram",
  axs: "AIS PLAY",
  ayb: "AsianDating",
  ayn: "Lime",
  ayo: "360Kredi",
  ayv: "myTVSUPER",
  azn: "UFC",
  baj: "Bipa",
  baq: "Redbubble",
  bav: "LeoList",
  bbd: "DBS Bank",
  bbf: "Neosurf",
  bbg: "Square",
  bbi: "aiqfome",
  bbk: "FilipinoCupid",
  bbr: "WalletHub",
  bbu: "InternationalCupid",
  bcq: "Mantan/Kopi Kenangan",
  bd: "X5ID",
  bdd: "BetMen",
  bdo: "AdaModal",
  bdp: "Kredito",
  bgn: "Veeka",
  bhb: "Wuling",
  bhz: "Eurobet",
  bih: "Indosaku",
  bix: "Hotel101",
  bkn: "betlive",
  bkz: "Rewardy",
  blh: "Winner",
  blo: "SiliconFlow 硅基流动",
  blp: "MEEFF",
  blr: "DocuSign",
  bme: "myIM3",
  bmj: "Betflag",
  bni: "Pets4Homes",
  bnt: "Treasury",
  bnu: "Qpon",
  bod: "Genspark",
  boo: "Casino Plus",
  bou: "汇旺 Huione Pay",
  bpp: "Bliq",
  bpq: "MChat",
  bqi: "Datanyze",
  bqm: "Beebs",
  bqn: "Upward",
  bqo: " Caffe Nero",
  bqp: "Zara",
  brg: "Letgo",
  brr: "LemFi",
  brt: "Netwin",
  bsa: "will",
  bsm: "Ahlan",
  bso: "PayWell",
  bss: "Trade Republic",
  bsw: "Milanuncios",
  btl: "D4",
  btx: "Amap 高德地图",
  bvh: "ParenTeam",
  bvi: "Salams",
  bwd: "Fetch",
  bwe: "Immutable Play",
  bwf: "MyGo",
  bxj: "Quero-Quero PAG",
  bxn: "Intel SAP",
  bxr: "AlFursan",
  byp: "Kaito",
  caj: "GoMoney",
  cam: "Eleme 饿了么",
  cb: "Bazos",
  cct: "Factory",
  ccv: "Triumph",
  ccw: "夸克  Quark",
  ccx: "Google Messenger",
  ej: "MrQ",
  gs: "SamsungShop",
  gx: "Hepsiburadacom",
  il: "IQOS",
  ir: "Chispa",
  jl: "Hopi",
  ju: "Indomaret",
  jx: "Swiggy",
  kl: "kolesa.kz",
  kv: "Rush",
  ls: "Careem",
  ly: "Olacabs",
  mw: "Transfergo",
  my: "CAIXA",
  ng: "FunPay",
  oe: "Codashop",
  oz: "Poshmark",
  pb: "SkyTV",
  pr: "Trendyol",
  pu: "Justdating",
  qo: "Moneylion",
  qx: "WorldRemit",
  rc: "Skype",
  si: "Cita Previa",
  sw: "NCsoft",
  tc: "Rumbler",
  te: "eFood",
  tl: "Truecaller",
  tp: "IndiaGold",
  ul: "Getir",
  uz: "OffGamers",
  vp: "Kwai",
  vy: "Meta",
  we: "DrugVokrug",
  ws: "Feeld",
  xr: "Tango",
  xu: "RecargaPay",
  xz: "paycell",
  yj: "eWallet",
  ym: "youla.ru",
  yu: "Xiaomi",
  zb: "FreeNow",
  zl: "Airtel",
  zn: "Biedronka",
  zr: "Papara",
  ve: "Dream11",
  bsy: "Air Miles",
  bkv: "Zen",
  bij: "Prodege",
  alp: "Mera Gaon",
  oj: "LoveRu",
  ft: "Bookmakers",
  jc: "IVI",
  bnp: "Airba Fresh",
  yk: "SportMaster",
  bri: "Gardrops",
  bhf: "InPost",
  wd: "Столото",
  cr: "TenChat",
  us: "IRCTC",
  aje: "CupidMedia",
  qr: "MEGA",
  wu: "PrivetMir",
  bmb: "Газпром ID",
  bsf: "Rupiah Cepat",
  bay: "Genome",
  blw: "BP",
  adj: "RummyCircle",
  bxw: "Credinex",
  aig: "Five Surveys",
  ha: "My11Circle",
  ayc: "HungerStation",
  bxp: "Tennents",
  auo: "Mycashbacks",
  jy: "Sorare",
  ajc: "Pochta Rossii",
  mi: "Zupee",
  bcy: "Finplus",
  bbt: "Blink",
  md: "Banks",
  bbj: "OnePay",
  bjz: "Jeevansathi",
  agx: "MeiQFashion",
  jr: "Samokat",
  bkw: "Bilkraft",
  bud: "WeTalk",
  rn: "neftm",
  azz: "Crystalbet",
  bly: "COSMOTE",
  hz: "Drom",
  bte: "CROCOBET",
  qh: "Oriflame",
  aih: "Fups",
  abl: "gpnbonus",
  ady: "TOKYO-CITY",
  kw: "Foody",
  ms: "NovaPoshta",
  bp: "GoFundMe",
  rj: "Detskiy mir",
  bmm: "Hey Cash",
  bko: "Vision Plus",
  aqm: "Tala",
  arc: "CHECK24",
  azl: "MotoRan ",
  ib: "Immowelt",
  bic: "Marktde",
  aeq: "Godrej",
  bwt: "Stanleybet",
  azy: "Casa Pariurilor",
  bck: "Onion Academy 洋葱学园",
  uv: "BinBin",
  aej: "Autoru",
  brf: "Dolap",
  agc: "VIMpay",
  sc: "Voggt",
  arr: "Linii Lybvi",
  boh: "Yophone",
  bdr: "Yara Farmcare",
  wp: "163СOM",
  bro: "YouGov Shopper",
  br: "Vkusno i Tochka",
  bqx: "Club Q8",
  bng: "Jush ",
  bhj: "Jòfogàs",
  akz: "Panvel",
  bwo: "KabanchikUA",
  bhl: "ati su",
  auj: "High 5 Casino",
  amy: "Otzovik",
  btq: "ЭЛПЛАТ",
  anw: "Premmia",
  ahd: "Midnite",
  tf: "Noon",
  apj: "Tinkoff VoiceKit",
  blx: "2ememain",
  bsl: "Oskelly",
  aeh: "Apteka Aprel",
  bls: "WeTV",
  sy: "Brahma",
  co: "Rediffmail",
  dt: "Delivery Club",
  boz: "Doctu",
  agb: "Smiles",
  bxc: "DRIVE2",
  apy: "Vinlab",
  yh: "hh",
  bzv: "TOP",
  blq: "Ari10",
  om: "Corona",
  bhe: "Jago",
  bcg: "2ГИС",
  bvs: "Вчасно",
  acw: "YouDo",
  ahk: "BlinBeri",
  ccz: "NxComm",
  ahr: "This Fate",
  nt: "Sravni",
  ace: "Tata Neu",
  mg: "Magnit",
  bpe: "Сільпо",
  blc: "Дикси",
  axm: "Não Me Perturbe",
  brv: "999 md",
  zg: "Setel",
  bst: "AdmiralBet",
  bpz: "Just Eat",
  asy: "Fore Coffee",
  of: "urent/jet/RuSharing",
  amz: "ImmoScout24",
  sv: "Dostavista",
  ky: "SpatenOktoberfest",
  bos: "Casino Portugal",
  bv: "Metro",
  hp: "Meesho",
  aul: "Alignable",
  dj: "LUKOIL-AZS",
  bwy: "Монетка",
  zt: "Budweiser",
  byw: "Annoncelight",
  py: "Monese",
  rk: "Fotka",
  agi: "Njuškalo",
  kq: "FotoCasa",
  bzb: "Big Cash",
  bog: "France Mobilities",
  bxv: "PAPER",
  asj: "T-online",
  bvu: "SwaRail ",
  btu: "DDX Fitness",
  hy: "Ininal",
  cac: "Vesseo",
  aoq: "JB Hi-Fi",
  cbh: "ZUL",
  ayr: "Superbet",
  ja: "Weverse",
  afa: "CDEK",
  bwl: "Guthabende",
  bxu: "Chronodrive",
  fw: "99acres",
  aab: "BharatPe",
  btv: "Radiate",
  bke: "FOOTDISTRICT",
  bku: "NL International",
  ail: "Smotryoshka",
  avt: "HuntTheMouse",
  bbs: "Ecoplatform",
  aqq: "MPSTATS",
  asq: "Warpcast",
  bnz: "Seven Bet",
  bol: "My TELUS",
  acd: "Cloud.ru",
  bye: "WhatsApp Business",
  cak: "Bazaraki",
  acu: "CityMall",
  ccy: "Authentify",
  bob: "Shell GO",
  axg: "Twin",
  bop: "Везёт",
  ahn: "Riv Gosh",
  acr: "QwikCilver",
  cm: "Prom",
  btp: "Связь ON",
  aat: "TamTam",
  gt: "Gett",
  bdb: "ОБИ",
  auf: "PREMIER",
  bai: "SNKRDUNK",
  bvj: "Санофи",
  ae: "myGLO",
  bsv: "AmarthaFin",
  cbb: "KeepCalling",
  rd: "Lenta",
  bje: "Meest",
  ta: "Wink",
  bxs: "LikeCard",
  qg: "MoneyPay",
  bif: "OPAP",
  ban: "BLINK by BonusLink",
  can: "BAGI",
  adw: "Profi",
  bdw: "Valora ",
  bcz: "UATAS",
  buy: "GetBlogger",
  bas: "Stoiximan",
  afu: "VseInstrumenty",
  ke: "Eldorado",
  box: "Thumbtack",
  aeg: "Flowwow",
  sl: "robota.ua",
  aes: "Zolotoye Yabloko",
  bfv: "Chocofamily",
  sd: "dodopizza",
  afc: "Bunda",
  js: "GolosZa",
  aid: "Kwiff",
  acn: "Gringo",
  arb: "Las Vegas Casino",
  bnf: "ContiCazino",
  bdt: "HOT51",
  ahc: "START",
  kj: "YAPPY",
  bem: "Shafa",
  aru: "UNNI 강남언니",
  bon: "RetailMeNot",
  ov: "Beget",
  azd: "Вплюсе",
  bqy: "SNAI",
  bga: "LPTracker",
  buj: "ASVLA",
  ny: "BitcoinBon",
  avu: "Karos",
  adv: "Cian",
  bjq: "Surveyon ",
  ami: "TEAMORU",
  bhp: "PPC",
  bau: "FieldStar",
  bvf: "GymPlius",
  bxf: "Disney Plus",
  lm: "FarPost",
  arx: "Zinia",
  bry: "Mobile DE",
  sh: "Vkusvill",
  cba: "Enilive",
  bjp: "Ria",
  xt: "Flipkart",
  ahf: "GAIL`s Bakery",
  gk: "AptekaRU",
  pv: "Koshelek",
  bcr: "ESX",
  cy: "PSA",
  ui: "RuTube",
  bpg: "НаПоправку",
  st: "Auchan",
  aos: "Loloo",
  afo: "KION ",
  adi: "Zepto",
  bns: "PAC Cash",
  azs: "Магнолия",
  aay: "JioMart",
  btm: "ZeeNow",
  xm: "Letual",
  qy: "Zhihu",
  bit: "Домклик",
  bnd: "КуулКлевер",
  tk: "MVideo",
  oc: "DealShare",
  bui: "OKbet",
  sb: "Lamoda",
  da: "MTS CashBack",
  bba: "SwitchUp",
  aox: "Aukro",
  brc: "Casa it",
  bzf: "Dabble",
  wt: "IZI",
  bla: "FDJ ParionsSport",
  vs: "WinzoGame",
  aug: "Magnit Market",
  bki: "MyACUVUE",
  adz: "Shokoladnica",
  tz: "Leyka",
};

export const SERVICE_ICONS: Record<string, string> = {
  tg: "✈️",
  wa: "📱",
  go: "🔍",
  vk: "🫂",
  fb: "📘",
  ig: "📸",
  tw: "🐦",
  tt: "🎵",
  ds: "🎮",
  vi: "📳",
  li: "💼",
  am: "📦",
  ms: "🪟",
  nf: "🎬",
  sp: "🎧",
  ub: "🚗",
  ft: "🛠️",
  pp: "💰",
  mm: "💳",
  zl: "💬",
  ln: "📲",
  si: "🔒",
  yr: "🌐",
  ma: "📧",
  ok: "👥",
  av: "🏷️",
  wb: "🛒",
  oz: "🏪",
  bb: "🚘",
  ai: "🏠",
  bk: "🏨",
  bt: "❤️",
  gr: "🌈",
  td: "💘",
  mt: "💑",
  bd: "😊",
  lf: "🎵",
  ot: "📋",
  sh: "👗",
  al: "🛍️",
  em: "🛒",
  et: "🎨",
  we: "💬",
  sk: "📞",
  zm: "🎥",
  yt: "▶️",
  pn: "📌",
  rd: "🤖",
  sg: "👻",
  fr: "💻",
  up: "💼",
  pm: "🍕",
  dv: "🍔",
  gb: "🥡",
  full: "📱",
  dr: "📱",
  gp: "📱",
  oi: "📱",
  ccu: "📱",
  ka: "📱",
  qf: "📱",
  ni: "📱",
  cq: "📱",
  jg: "📱",
  wr: "📱",
  mb: "📱",
  ts: "📱",
  hw: "📱",
  kc: "📱",
  nv: "📱",
  yw: "📱",
  vz: "📱",
  ew: "📱",
  bw: "📱",
  aoy: "📱",
  me: "📱",
  fu: "📱",
  ki: "📱",
  dh: "📱",
  im: "📱",
  wx: "📱",
  tn: "📱",
  aop: "📱",
  vm: "📱",
  abk: "📱",
  df: "📱",
  xk: "📱",
  ac: "📱",
  abu: "📱",
  aka: "📱",
  alg: "📱",
  pf: "📱",
  vr: "📱",
  xh: "📱",
  bzk: "📱",
  dl: "📱",
  fz: "📱",
  ev: "📱",
  xd: "📱",
  mo: "📱",
  tm: "📱",
  nz: "📱",
  anx: "📱",
  blt: "📱",
  sn: "📱",
  ue: "📱",
  ya: "📱",
  tx: "📱",
  bz: "📱",
  bwv: "📱",
  pc: "📱",
  zk: "📱",
  ada: "📱",
  zs: "📱",
  bgv: "📱",
  qj: "📱",
  aim: "📱",
  aaa: "📱",
  uf: "📱",
  xx: "📱",
  zh: "📱",
  afp: "📱",
  ang: "📱",
  cn: "📱",
  bex: "📱",
  blz: "📱",
  awv: "📱",
  bxy: "📱",
  yx: "📱",
  fv: "📱",
  abc: "📱",
  do: "📱",
  aba: "📱",
  pd: "📱",
  acz: "📱",
  axj: "📱",
  aez: "📱",
  byf: "📱",
  ah: "📱",
  bpc: "📱",
  nc: "📱",
  rr: "📱",
  axx: "📱",
  yl: "📱",
  amb: "📱",
  qv: "📱",
  aik: "📱",
  ars: "📱",
  bib: "📱",
  bnl: "📱",
  hc: "📱",
  anh: "📱",
  apr: "📱",
  akp: "📱",
  als: "📱",
  bwu: "📱",
  ahl: "📱",
  aqt: "📱",
  uk: "📱",
  abn: "📱",
  azi: "📱",
  bc: "📱",
  kt: "📱",
  za: "📱",
  abg: "📱",
  adu: "📱",
  agl: "📱",
  aon: "📱",
  asb: "📱",
  hx: "📱",
  bgt: "📱",
  aiw: "📱",
  cw: "📱",
  jq: "📱",
  cau: "📱",
  arf: "📱",
  bqh: "📱",
  byh: "📱",
  wh: "📱",
  aym: "📱",
  cj: "📱",
  qq: "📱",
  ua: "📱",
  bl: "📱",
  gf: "📱",
  ns: "📱",
  akr: "📱",
  bo: "📱",
  gq: "📱",
  re: "📱",
  aff: "📱",
  afs: "📱",
  afz: "📱",
  bfg: "📱",
  bpt: "📱",
  bru: "📱",
  ef: "📱",
  ip: "📱",
  uu: "📱",
  acm: "📱",
  akd: "📱",
  ayz: "📱",
  bcx: "📱",
  bkd: "📱",
  cp: "📱",
  ep: "📱",
  fk: "📱",
  gj: "📱",
  mx: "📱",
  nh: "📱",
  atl: "📱",
  awz: "📱",
  axn: "📱",
  bn: "📱",
  ccl: "📱",
  zy: "📱",
  afr: "📱",
  ark: "📱",
  auh: "📱",
  bny: "📱",
  brk: "📱",
  hb: "📱",
  ij: "📱",
  kk: "📱",
  km: "📱",
  lj: "📱",
  ry: "📱",
  tu: "📱",
  abe: "📱",
  abo: "📱",
  app: "📱",
  aup: "📱",
  ber: "📱",
  btr: "📱",
  bwx: "📱",
  dp: "📱",
  kf: "📱",
  rl: "📱",
  xs: "📱",
  agm: "📱",
  ajj: "📱",
  ani: "📱",
  aws: "📱",
  axr: "📱",
  bbq: "📱",
  bfo: "📱",
  bii: "📱",
  bkk: "📱",
  btn: "📱",
  bzo: "📱",
  sa: "📱",
  sr: "📱",
  ww: "📱",
  zd: "📱",
  afe: "📱",
  agj: "📱",
  ahb: "📱",
  ahi: "📱",
  ahj: "📱",
  ahx: "📱",
  alm: "📱",
  aor: "📱",
  aq: "📱",
  arp: "📱",
  atn: "📱",
  atr: "📱",
  axt: "📱",
  cbs: "📱",
  ex: "📱",
  ht: "📱",
  ti: "📱",
  vg: "📱",
  yy: "📱",
  adt: "📱",
  aem: "📱",
  afn: "📱",
  agw: "📱",
  ahe: "📱",
  aiq: "📱",
  ais: "📱",
  aix: "📱",
  ajn: "📱",
  alj: "📱",
  anm: "📱",
  aoi: "📱",
  aok: "📱",
  aqy: "📱",
  aux: "📱",
  auz: "📱",
  avb: "📱",
  bgj: "📱",
  bli: "📱",
  blm: "📱",
  bow: "📱",
  bqe: "📱",
  bwa: "📱",
  ee: "📱",
  ff: "📱",
  fs: "📱",
  ge: "📱",
  hu: "📱",
  ie: "📱",
  pz: "📱",
  qe: "📱",
  rs: "📱",
  rt: "📱",
  wg: "📱",
  zo: "📱",
  abh: "📱",
  ael: "📱",
  aer: "📱",
  afm: "📱",
  aga: "📱",
  agd: "📱",
  ait: "📱",
  aiv: "📱",
  aiz: "📱",
  ako: "📱",
  alb: "📱",
  anj: "📱",
  anl: "📱",
  aoe: "📱",
  aol: "📱",
  aoz: "📱",
  apb: "📱",
  apd: "📱",
  apf: "📱",
  aps: "📱",
  auc: "📱",
  awr: "📱",
  axp: "📱",
  bab: "📱",
  bbl: "📱",
  bbm: "📱",
  bdg: "📱",
  bdh: "📱",
  bfa: "📱",
  bfr: "📱",
  bfw: "📱",
  bhr: "📱",
  bji: "📱",
  ble: "📱",
  bmd: "📱",
  bmi: "📱",
  bmx: "📱",
  bpi: "📱",
  bqb: "📱",
  bqr: "📱",
  bra: "📱",
  bre: "📱",
  bsu: "📱",
  btd: "📱",
  bxg: "📱",
  bxi: "📱",
  byd: "📱",
  cbk: "📱",
  dg: "📱",
  dy: "📱",
  fd: "📱",
  fh: "📱",
  gm: "📱",
  ji: "📱",
  lc: "📱",
  mv: "📱",
  nq: "📱",
  tr: "📱",
  tv: "📱",
  vd: "📱",
  wc: "📱",
  xy: "📱",
  yi: "📱",
  yn: "📱",
  ze: "📱",
  zp: "📱",
  aag: "📱",
  aaq: "📱",
  aav: "📱",
  aax: "📱",
  aaz: "📱",
  abb: "📱",
  abd: "📱",
  abq: "📱",
  abt: "📱",
  acb: "📱",
  acc: "📱",
  aci: "📱",
  adc: "📱",
  adp: "📱",
  aet: "📱",
  aeu: "📱",
  aex: "📱",
  aey: "📱",
  afd: "📱",
  afk: "📱",
  agg: "📱",
  agh: "📱",
  agk: "📱",
  agv: "📱",
  ahv: "📱",
  ajq: "📱",
  aju: "📱",
  ajv: "📱",
  ajy: "📱",
  akj: "📱",
  akl: "📱",
  akm: "📱",
  alo: "📱",
  alx: "📱",
  aly: "📱",
  ama: "📱",
  amw: "📱",
  ana: "📱",
  anb: "📱",
  ane: "📱",
  ann: "📱",
  ano: "📱",
  anq: "📱",
  aof: "📱",
  aoh: "📱",
  aom: "📱",
  aoo: "📱",
  aow: "📱",
  apg: "📱",
  api: "📱",
  apl: "📱",
  apo: "📱",
  apq: "📱",
  aqj: "📱",
  are: "📱",
  ari: "📱",
  asf: "📱",
  asp: "📱",
  atp: "📱",
  atu: "📱",
  aua: "📱",
  aub: "📱",
  avj: "📱",
  avk: "📱",
  avv: "📱",
  awg: "📱",
  awq: "📱",
  awu: "📱",
  axs: "📱",
  ayb: "📱",
  ayn: "📱",
  ayo: "📱",
  ayv: "📱",
  azn: "📱",
  baj: "📱",
  baq: "📱",
  bav: "📱",
  bbd: "📱",
  bbf: "📱",
  bbg: "📱",
  bbi: "📱",
  bbk: "📱",
  bbr: "📱",
  bbu: "📱",
  bcq: "📱",
  bdd: "📱",
  bdo: "📱",
  bdp: "📱",
  bgn: "📱",
  bhb: "📱",
  bhz: "📱",
  bih: "📱",
  bix: "📱",
  bkn: "📱",
  bkz: "📱",
  blh: "📱",
  blo: "📱",
  blp: "📱",
  blr: "📱",
  bme: "📱",
  bmj: "📱",
  bni: "📱",
  bnt: "📱",
  bnu: "📱",
  bod: "📱",
  boo: "📱",
  bou: "📱",
  bpp: "📱",
  bpq: "📱",
  bqi: "📱",
  bqm: "📱",
  bqn: "📱",
  bqo: "📱",
  bqp: "📱",
  brg: "📱",
  brr: "📱",
  brt: "📱",
  bsa: "📱",
  bsm: "📱",
  bso: "📱",
  bss: "📱",
  bsw: "📱",
  btl: "📱",
  btx: "📱",
  bvh: "📱",
  bvi: "📱",
  bwd: "📱",
  bwe: "📱",
  bwf: "📱",
  bxj: "📱",
  bxn: "📱",
  bxr: "📱",
  byp: "📱",
  caj: "📱",
  cam: "📱",
  cb: "📱",
  cct: "📱",
  ccv: "📱",
  ccw: "📱",
  ccx: "📱",
  ej: "📱",
  gs: "📱",
  gx: "📱",
  il: "📱",
  ir: "📱",
  jl: "📱",
  ju: "📱",
  jx: "📱",
  kl: "📱",
  kv: "📱",
  ls: "📱",
  ly: "📱",
  mw: "📱",
  my: "📱",
  ng: "📱",
  oe: "📱",
  pb: "📱",
  pr: "📱",
  pu: "📱",
  qo: "📱",
  qx: "📱",
  rc: "📱",
  sw: "📱",
  tc: "📱",
  te: "📱",
  tl: "📱",
  tp: "📱",
  ul: "📱",
  uz: "📱",
  vp: "📱",
  vy: "📱",
  ws: "📱",
  xr: "📱",
  xu: "📱",
  xz: "📱",
  yj: "📱",
  ym: "📱",
  yu: "📱",
  zb: "📱",
  zn: "📱",
  zr: "📱",
  ve: "📱",
  bsy: "📱",
  bkv: "📱",
  bij: "📱",
  alp: "📱",
  oj: "📱",
  jc: "📱",
  bnp: "📱",
  yk: "📱",
  bri: "📱",
  bhf: "📱",
  wd: "📱",
  cr: "📱",
  us: "📱",
  aje: "📱",
  qr: "📱",
  wu: "📱",
  bmb: "📱",
  bsf: "📱",
  bay: "📱",
  blw: "📱",
  adj: "📱",
  bxw: "📱",
  aig: "📱",
  ha: "📱",
  ayc: "📱",
  bxp: "📱",
  auo: "📱",
  jy: "📱",
  ajc: "📱",
  mi: "📱",
  bcy: "📱",
  bbt: "📱",
  md: "📱",
  bbj: "📱",
  bjz: "📱",
  agx: "📱",
  jr: "📱",
  bkw: "📱",
  bud: "📱",
  rn: "📱",
  azz: "📱",
  bly: "📱",
  hz: "📱",
  bte: "📱",
  qh: "📱",
  aih: "📱",
  abl: "📱",
  ady: "📱",
  kw: "📱",
  bp: "📱",
  rj: "📱",
  bmm: "📱",
  bko: "📱",
  aqm: "📱",
  arc: "📱",
  azl: "📱",
  ib: "📱",
  bic: "📱",
  aeq: "📱",
  bwt: "📱",
  azy: "📱",
  bck: "📱",
  uv: "📱",
  aej: "📱",
  brf: "📱",
  agc: "📱",
  sc: "📱",
  arr: "📱",
  boh: "📱",
  bdr: "📱",
  wp: "📱",
  bro: "📱",
  br: "📱",
  bqx: "📱",
  bng: "📱",
  bhj: "📱",
  akz: "📱",
  bwo: "📱",
  bhl: "📱",
  auj: "📱",
  amy: "📱",
  btq: "📱",
  anw: "📱",
  ahd: "📱",
  tf: "📱",
  apj: "📱",
  blx: "📱",
  bsl: "📱",
  aeh: "📱",
  bls: "📱",
  sy: "📱",
  co: "📱",
  dt: "📱",
  boz: "📱",
  agb: "📱",
  bxc: "📱",
  apy: "📱",
  yh: "📱",
  bzv: "📱",
  blq: "📱",
  om: "📱",
  bhe: "📱",
  bcg: "📱",
  bvs: "📱",
  acw: "📱",
  ahk: "📱",
  ccz: "📱",
  ahr: "📱",
  nt: "📱",
  ace: "📱",
  mg: "📱",
  bpe: "📱",
  blc: "📱",
  axm: "📱",
  brv: "📱",
  zg: "📱",
  bst: "📱",
  bpz: "📱",
  asy: "📱",
  of: "📱",
  amz: "📱",
  sv: "📱",
  ky: "📱",
  bos: "📱",
  bv: "📱",
  hp: "📱",
  aul: "📱",
  dj: "📱",
  bwy: "📱",
  zt: "📱",
  byw: "📱",
  py: "📱",
  rk: "📱",
  agi: "📱",
  kq: "📱",
  bzb: "📱",
  bog: "📱",
  bxv: "📱",
  asj: "📱",
  bvu: "📱",
  btu: "📱",
  hy: "📱",
  cac: "📱",
  aoq: "📱",
  cbh: "📱",
  ayr: "📱",
  ja: "📱",
  afa: "📱",
  bwl: "📱",
  bxu: "📱",
  fw: "📱",
  aab: "📱",
  btv: "📱",
  bke: "📱",
  bku: "📱",
  ail: "📱",
  avt: "📱",
  bbs: "📱",
  aqq: "📱",
  asq: "📱",
  bnz: "📱",
  bol: "📱",
  acd: "📱",
  bye: "📱",
  cak: "📱",
  acu: "📱",
  ccy: "📱",
  bob: "📱",
  axg: "📱",
  bop: "📱",
  ahn: "📱",
  acr: "📱",
  cm: "📱",
  btp: "📱",
  aat: "📱",
  gt: "📱",
  bdb: "📱",
  auf: "📱",
  bai: "📱",
  bvj: "📱",
  ae: "📱",
  bsv: "📱",
  cbb: "📱",
  bje: "📱",
  ta: "📱",
  bxs: "📱",
  qg: "📱",
  bif: "📱",
  ban: "📱",
  can: "📱",
  adw: "📱",
  bdw: "📱",
  bcz: "📱",
  buy: "📱",
  bas: "📱",
  afu: "📱",
  ke: "📱",
  box: "📱",
  aeg: "📱",
  sl: "📱",
  aes: "📱",
  bfv: "📱",
  sd: "📱",
  afc: "📱",
  js: "📱",
  aid: "📱",
  acn: "📱",
  arb: "📱",
  bnf: "📱",
  bdt: "📱",
  ahc: "📱",
  kj: "📱",
  bem: "📱",
  aru: "📱",
  bon: "📱",
  ov: "📱",
  azd: "📱",
  bqy: "📱",
  bga: "📱",
  buj: "📱",
  ny: "📱",
  avu: "📱",
  adv: "📱",
  bjq: "📱",
  ami: "📱",
  bhp: "📱",
  bau: "📱",
  bvf: "📱",
  bxf: "📱",
  lm: "📱",
  arx: "📱",
  bry: "📱",
  cba: "📱",
  bjp: "📱",
  xt: "📱",
  ahf: "📱",
  gk: "📱",
  pv: "📱",
  bcr: "📱",
  cy: "📱",
  ui: "📱",
  bpg: "📱",
  st: "📱",
  aos: "📱",
  afo: "📱",
  adi: "📱",
  bns: "📱",
  azs: "📱",
  aay: "📱",
  btm: "📱",
  xm: "📱",
  qy: "📱",
  bit: "📱",
  bnd: "📱",
  tk: "📱",
  oc: "📱",
  bui: "📱",
  sb: "📱",
  da: "📱",
  bba: "📱",
  aox: "📱",
  brc: "📱",
  bzf: "📱",
  wt: "📱",
  bla: "📱",
  vs: "📱",
  aug: "📱",
  bki: "📱",
  adz: "📱",
  tz: "📱",
};

export function getServiceName(code: string, activationType: string): string {
  if (activationType === "email") {
    return "Email · " + code.replace("email_", "").replace("EMAIL_", "");
  }
  const lower = code.toLowerCase().replace("email_", "");
  return SERVICE_NAMES[lower] || code.toUpperCase();
}

export function getServiceIcon(code: string, activationType: string): string {
  if (activationType === "email") return "📧";
  const lower = code.toLowerCase();
  return SERVICE_ICONS[lower] || "📱";
}

export function getServiceIconUrl(code: string): string {
  const lower = code.toLowerCase().replace("email_", "");
  return `/assets/img/service/${lower}0.webp`;
}
